import cn from 'classnames';
import styles from './RewardCalculationCard.module.css';
import { FunctionComponent } from 'react';
import { Card } from 'react-bootstrap';

export interface IRewardCalculationCardProps {
    title: string;
    summary: string;
    description: string[];
    className?: string;
}

const RewardCalculationCard: FunctionComponent<IRewardCalculationCardProps> = ({title, summary, description, className }) => {

    return (
        <Card bsPrefix={cn(styles.rewardCalculationCard, className)}>
            <Card.Header className={styles.header}>
                <Card.Title as={'div'} bsPrefix={styles.title}>{title}</Card.Title>
                <Card.Text as={'div'} bsPrefix={styles.summary}>{summary}</Card.Text>
            </Card.Header>
            <Card.Body className={styles.body}>
                {description.map((item, index) => (
                    <Card.Text as={'div'} bsPrefix={styles.text} key={index}>{item}</Card.Text>
                ))}
            </Card.Body>
        </Card>
    );
};

export default RewardCalculationCard;
